/* ==========================================================================
   Floating Add to Cart — variant link  —  assets/floating-atc-inline.js
   Pairs with snippets/floating-atc-link.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var SYNC_INTERVAL = 300; // ms — how often we re-check the theme's own variant input
  var TARGET_ID = 'FloatingAtcVariantTarget';

  // Where the variant name links to, most specific first.
  var TARGET_SELECTORS = [
    '[data-fatc-variant-target]',
    'variant-selects',
    'variant-radios',
    '.variant-wrapper',
    '.product-block--variant-picker',
    '.product-single__variants',
    '[data-product-variants]',
    '.selector-wrapper',
    'form[action*="/cart/add"] select[name^="options"]',
    'form[action*="/cart/add"] fieldset'
  ];

  // Candidates for a sticky header we need to scroll clear of.
  var HEADER_SELECTORS = [
    '.site-header--fixed',
    '.site-header',
    '#SiteHeader',
    '#shopify-section-header',
    'header[role="banner"]',
    '.header-wrapper',
    'sticky-header'
  ];

  function init() {
    var root = document.getElementById('FloatingAtcInline');
    if (!root || root.dataset.fatcReady === 'true') return;
    root.dataset.fatcReady = 'true';

    var cfg = {
      position: root.dataset.position || 'bottom',
      trigger: root.dataset.trigger || '',
      target: root.dataset.target || '',
      scrollOffset: parseInt(root.dataset.scrollOffset, 10) || 0,
      highlightMs: (parseFloat(root.dataset.highlightDuration) || 1.6) * 1000,
      fallbackScroll: parseInt(root.dataset.fallbackScroll, 10) || 600,
      afterAdd: root.dataset.afterAdd || 'drawer',
      ajax: root.dataset.ajax !== 'false',
      addUrl: root.dataset.addUrl || '/cart/add',
      cartUrl: root.dataset.cartUrl || '/cart',
      soldOutLabel: root.dataset.soldoutLabel || 'Sold out',
      buttonLabel: root.dataset.buttonLabel || 'Add to cart',
      addedLabel: root.dataset.addedLabel || 'Added',
      updateUrl: root.dataset.updateUrl !== 'false'
    };

    var els = {
      form: root.querySelector('[data-fatc-form]'),
      variantInput: root.querySelector('[data-fatc-variant-input]'),
      variantLink: root.querySelector('[data-fatc-variant-link]'),
      sep: root.querySelector('[data-fatc-sep]'),
      price: root.querySelector('[data-fatc-price]'),
      compare: root.querySelector('[data-fatc-compare]'),
      image: root.querySelector('[data-fatc-image]'),
      button: root.querySelector('[data-fatc-button]'),
      buttonLabel: root.querySelector('[data-fatc-button-label]'),
      error: root.querySelector('[data-fatc-error]')
    };

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-fatc-variants]').textContent);
    } catch (e) {
      variants = [];
    }

    var currentId = els.variantInput ? String(els.variantInput.value) : '';
    var trigger = null;
    var observer = null;
    var visible = false;
    var highlightTimer = null;

    /* ---------------------------------------------------------------- show/hide */

    function show() {
      if (visible) return;
      visible = true;
      root.classList.add('is-visible');
      root.setAttribute('aria-hidden', 'false');
    }

    function hide() {
      if (!visible) return;
      visible = false;
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      clearError();
    }

    function findTrigger() {
      var parts = cfg.trigger.split(',');
      for (var i = 0; i < parts.length; i++) {
        var sel = parts[i].trim();
        if (!sel) continue;
        var matches;
        try {
          matches = document.querySelectorAll(sel);
        } catch (e) {
          continue;
        }
        for (var j = 0; j < matches.length; j++) {
          var el = matches[j];
          if (root.contains(el)) continue;
          if (!el.offsetParent && el.offsetHeight === 0) continue;
          return el;
        }
      }
      return null;
    }

    function evaluate(el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom <= 0) show();
      else hide();
    }

    function watchTrigger() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      trigger = findTrigger();

      if (!trigger) {
        window.addEventListener('scroll', onFallbackScroll, { passive: true });
        onFallbackScroll();
        return;
      }

      window.removeEventListener('scroll', onFallbackScroll);

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) hide();
            else evaluate(entry.target);
          });
        }, { threshold: 0 });
        observer.observe(trigger);
        evaluate(trigger);
      } else {
        window.addEventListener('scroll', onLegacyScroll, { passive: true });
        onLegacyScroll();
      }
    }

    function onLegacyScroll() {
      if (trigger) evaluate(trigger);
    }

    function onFallbackScroll() {
      if (window.pageYOffset > cfg.fallbackScroll) show();
      else hide();
    }

    /* -------------------------------------------------------- jump to the picker */

    // Height of anything pinned to the top of the viewport, so the picker does
    // not land underneath it.
    function stickyHeaderHeight() {
      var tallest = 0;
      HEADER_SELECTORS.forEach(function (sel) {
        var el;
        try {
          el = document.querySelector(sel);
        } catch (e) {
          return;
        }
        if (!el) return;
        var position = window.getComputedStyle(el).position;
        if (position !== 'fixed' && position !== 'sticky') return;
        var rect = el.getBoundingClientRect();
        if (rect.top > 60 || rect.height === 0) return; // not pinned to the top
        if (rect.height > tallest) tallest = rect.height;
      });
      return tallest;
    }

    function findTarget() {
      var selectors = cfg.target ? [cfg.target].concat(TARGET_SELECTORS) : TARGET_SELECTORS;
      for (var i = 0; i < selectors.length; i++) {
        var matches;
        try {
          matches = document.querySelectorAll(selectors[i]);
        } catch (e) {
          continue;
        }
        for (var j = 0; j < matches.length; j++) {
          var el = matches[j];
          if (root.contains(el)) continue;
          if (!el.offsetParent && el.offsetHeight === 0) continue;
          return el;
        }
      }
      // Last resort: the theme's add-to-cart button, or its form.
      if (trigger) return trigger.closest('form') || trigger;
      return null;
    }

    // Keep the anchor href pointing at something real, so the link still works
    // as a plain anchor if the click handler is bypassed.
    function prepareTarget() {
      var target = findTarget();
      if (!target || !els.variantLink) return target;
      if (!target.id) target.id = TARGET_ID;
      els.variantLink.setAttribute('href', '#' + target.id);
      target.style.scrollMarginTop = stickyHeaderHeight() + cfg.scrollOffset + 'px';
      return target;
    }

    function highlight(target) {
      if (!target) return;
      clearTimeout(highlightTimer);
      target.classList.remove('fatc-target-highlight');
      void target.offsetWidth; // restart the animation
      target.classList.add('fatc-target-highlight');
      highlightTimer = setTimeout(function () {
        target.classList.remove('fatc-target-highlight');
      }, cfg.highlightMs + 100);
    }

    function jumpToPicker(event) {
      var target = prepareTarget();
      if (!target) return; // let the browser do whatever the href says

      if (event) event.preventDefault();

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = target.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight() - cfg.scrollOffset;

      window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
      highlight(target);
    }

    if (els.variantLink) {
      els.variantLink.addEventListener('click', function (event) {
        // Leave modified clicks alone (new tab, etc.)
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        jumpToPicker(event);
      });
    }

    /* ------------------------------------------------------------ variant state */

    function variantById(id) {
      id = String(id);
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) return variants[i];
      }
      return null;
    }

    function render(variant) {
      if (!variant) return;

      if (els.variantInput) els.variantInput.value = variant.id;
      if (els.price) els.price.textContent = variant.price;
      if (els.compare) els.compare.textContent = variant.compare_at_price || '';
      if (els.image && variant.image) els.image.src = variant.image;

      if (els.variantLink) {
        var named = variants.length > 1 && variant.title && variant.title !== 'Default Title';
        els.variantLink.textContent = variant.title;
        els.variantLink.hidden = !named;
        if (els.sep) els.sep.hidden = !named;
      }

      if (els.button) {
        els.button.disabled = !variant.available;
        if (els.buttonLabel) {
          els.buttonLabel.textContent = variant.available ? cfg.buttonLabel : cfg.soldOutLabel;
        }
      }
      currentId = String(variant.id);
    }

    function isVisible(el) {
      return !!(el.offsetParent || el.offsetWidth || el.offsetHeight);
    }

    function variantInputOf(form) {
      return form.querySelector('input[name="id"], select[name="id"]');
    }

    // The theme's own product form. Picking the first /cart/add form on the
    // page is not enough: once the cart drawer has been opened it may leave
    // its own forms (upsells, recommendations) in the DOM, often earlier in
    // document order than the product form. So a candidate only counts if its
    // variant input names one of THIS product's variants, and a visible form
    // always beats a hidden one.
    function getMainForm() {
      // The form wrapping the add-to-cart button we already track is the
      // surest answer, when we have one.
      if (trigger && !root.contains(trigger) && trigger.closest) {
        var owned = trigger.closest('form[action*="/cart/add"]');
        if (owned && variantInputOf(owned)) return owned;
      }

      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      var hiddenMatch = null;

      for (var i = 0; i < forms.length; i++) {
        var form = forms[i];
        if (root.contains(form)) continue;

        var input = variantInputOf(form);
        if (!input || !input.value) continue;
        if (!variantById(input.value)) continue; // another product's form

        if (isVisible(form)) return form;
        if (!hiddenMatch) hiddenMatch = form;
      }

      return hiddenMatch;
    }

    // Themes usually set their hidden variant input programmatically without
    // firing an event, so this is polled rather than event-driven.
    function pullFromTheme() {
      var mainForm = getMainForm();
      if (!mainForm) return;
      var hidden = mainForm.querySelector('input[name="id"], select[name="id"]');
      if (!hidden || !hidden.value) return;
      if (String(hidden.value) === currentId) return;
      var variant = variantById(hidden.value);
      if (!variant) return;

      render(variant);

      if (cfg.updateUrl && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          /* non-fatal */
        }
      }

      document.dispatchEvent(
        new CustomEvent('fatc:variant:change', { detail: { variant: variant }, bubbles: true })
      );
    }

    ['variant:change', 'theme:variant:change', 'variantChange', 'product:variant-change'].forEach(function (name) {
      document.addEventListener(name, pullFromTheme);
    });

    /* ---------------------------------------------------------------- add to cart */

    function clearError() {
      root.classList.remove('has-error');
      if (els.error) els.error.textContent = '';
    }

    function showError(message) {
      if (!els.error) return;
      els.error.textContent = message;
      root.classList.add('has-error');
    }

    function flashAdded() {
      if (!els.buttonLabel) return;
      var original = els.buttonLabel.textContent;
      els.buttonLabel.textContent = cfg.addedLabel;
      setTimeout(function () {
        els.buttonLabel.textContent = original;
      }, 2000);
    }

    function themeAddButton() {
      if (trigger && /^(BUTTON|INPUT)$/.test(trigger.tagName) && !trigger.disabled) return trigger;
      var candidates = document.querySelectorAll(
        '[data-fatc-trigger], form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"], button[name="add"]'
      );
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (root.contains(el) || el.disabled) continue;
        if (!el.offsetParent && el.offsetHeight === 0) continue;
        return el;
      }
      return null;
    }

    function openDrawer(json) {
      var drawer = document.querySelector('cart-drawer, cart-notification');
      if (drawer && typeof drawer.renderContents === 'function' && json && json.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(json);
        return true;
      }

      ['cart:build', 'cart:refresh', 'cart:updated', 'cart:open', 'ajaxProduct:added'].forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { detail: json, bubbles: true }));
      });

      var toggle = document.querySelector(
        '[data-cart-toggle], .js-drawer-open-cart, .js-drawer-open-button-right, #CartToggle, .site-header__cart, [data-drawer-toggle="CartDrawer"]'
      );
      if (toggle) toggle.click();

      return true;
    }

    if (els.form) {
      els.form.addEventListener('submit', function (event) {
        if (!cfg.ajax) return;
        event.preventDefault();
        clearError();

        // Preferred path: press the theme's own button so the theme handles the
        // add and opens its own cart drawer.
        if (cfg.afterAdd === 'drawer') {
          var native = themeAddButton();
          if (native) {
            flashAdded();
            native.click();
            return;
          }
        }

        var body = new FormData(els.form);
        if (document.querySelector('cart-drawer')) {
          body.append('sections', 'cart-drawer,cart-icon-bubble');
          body.append('sections_url', window.location.pathname);
        }

        els.button.classList.add('is-loading');
        els.button.disabled = true;

        fetch(cfg.addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            if (json.status || json.errors) {
              throw new Error(json.description || json.message || 'Could not add this item.');
            }

            document.dispatchEvent(new CustomEvent('fatc:added', { detail: json, bubbles: true }));

            if (cfg.afterAdd === 'cart') {
              window.location.href = cfg.cartUrl;
              return;
            }
            if (cfg.afterAdd === 'drawer') {
              openDrawer(json);
              flashAdded();
              return;
            }
            flashAdded();
          })
          .catch(function (error) {
            showError(error.message || 'Could not add this item.');
          })
          .finally(function () {
            els.button.classList.remove('is-loading');
            var variant = variantById(currentId);
            els.button.disabled = !!(variant && !variant.available);
          });
      });
    }

    /* ---------------------------------------------------------------- lifecycle */

    watchTrigger();
    prepareTarget();
    root.__fatcRefresh = function () {
      watchTrigger();
      prepareTarget();
    };

    var timer = setInterval(function () {
      if (!document.body.contains(root)) {
        clearInterval(timer);
        return;
      }
      if (!trigger || !document.body.contains(trigger)) watchTrigger();
      pullFromTheme();
    }, SYNC_INTERVAL);

    window.addEventListener('resize', function () {
      if (trigger) evaluate(trigger);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    var root = document.getElementById('FloatingAtcInline');
    if (root && typeof root.__fatcRefresh === 'function') root.__fatcRefresh();
    else init();
  });
})();
